var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/user_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 11 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.06139C12.9289 5.06139 11.25 6.76094 11.25 8.85743C11.25 10.9539 12.9289 12.6535 15 12.6535C17.0711 12.6535 18.75 10.9539 18.75 8.85743C18.75 6.76094 17.0711 5.06139 15 5.06139ZM8.75 8.85743C8.75 5.36327 11.5482 2.53069 15 2.53069C18.4518 2.53069 21.25 5.36327 21.25 8.85743C21.25 12.3516 18.4518 15.1842 15 15.1842C11.5482 15.1842 8.75 12.3516 8.75 8.85743Z",
    fill: "url(#paint0_linear_1_385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 12 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 25.307C11.3388 25.307 9.16818 24.1857 7.91912 22.7393C7.53853 22.2985 7.43934 21.9112 7.45085 21.5933C7.46312 21.2542 7.60794 20.8617 7.93392 20.4596C8.60351 19.6336 9.87655 18.9802 11.2499 18.9802H18.7499C20.1232 18.9802 21.3963 19.6336 22.0659 20.4596C22.3919 20.8617 22.5367 21.2542 22.5489 21.5933C22.5604 21.9112 22.4613 22.2985 22.0807 22.7393C20.8316 24.1857 18.661 25.307 14.9999 25.307ZM6.03687 24.4048C7.87758 26.5364 10.8165 27.8376 14.9999 27.8376C19.1833 27.8376 22.1222 26.5364 23.9629 24.4048C24.7182 23.5302 25.0844 22.5277 25.0473 21.5007C25.0109 20.495 24.593 19.5876 23.9985 18.8542C22.8271 17.4093 20.8283 16.4495 18.7499 16.4495H11.2499C9.17146 16.4495 7.17269 17.4093 6.00133 18.8542C5.40684 19.5876 4.98891 20.495 4.95252 21.5007C4.91536 22.5277 5.28159 23.5302 6.03687 24.4048Z",
    fill: "url(#paint1_linear_1_385)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_385",
    x1: 8.96024,
    y1: 2.53069,
    x2: 21.5181,
    y2: 2.80256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_385",
    x1: 5.28802,
    y1: 27.8376,
    x2: 25.4602,
    y2: 27.0574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.99b3c2c54cf24750f0b4d6c7ecd903f2.svg";
export { ForwardRef as ReactComponent };